import SocialSecurityContributionComponent from "../components/SocialSecurityContribution";
import useSocialSecurityContribution from "../hooks/useSocialSecurityContribution";

const SocialSecurityContribution = () => {
  const socialSecurityContributionProps = useSocialSecurityContribution();
  return <SocialSecurityContributionComponent {...socialSecurityContributionProps} />;
};

export default SocialSecurityContribution;
